module.exports = __webpack_public_path__ + "static/media/blind_man.37430217.png";